const types = require('../constants/actionTypes');
const filterUnique = require('utilities/filterUnique');

const initialState = [];

const investmentFundsReducer = (state = initialState, action) => {
    switch(action.type) {
        case(types.FUNDS_FETCH_SUCCEEDED): {
            const { funds } = action.payload;
            return [ ...state, ...funds ].filter(filterUnique);
        }
        case(types.FUNDS_SET_CLOSE_PRICE): {
            const newState = state.map(fund => {
                if(fund.isin === action.payload.isin) {
                    return { ...fund, closePrice: action.payload.response };
                }
                return fund;
            });
            return newState;
        }
        case( types.FETCH_ALTERNATIVE_DOCUMENTS_SUCCESS): {
            const { isin, documents } = action.payload;
            const newState = state.map(fund => {
                if(fund.isin === isin) {
                    return { ...fund, alternativeDocuments: {...fund.alternativeDocuments, ...documents} };
                }
                return fund;
            });
            return newState;
        }
        default:
            return state;
    }
};

module.exports = investmentFundsReducer;
